import React, { useState, forwardRef, useImperativeHandle } from 'react'
import { useAnnouncements } from 'hooks'
import { useAuth } from 'context'
import { AnnouncementService } from 'utility/services'
import { AnnouncementList } from './AnnouncementList'
import { AnnouncementModal } from './AnnouncementModal'

export const AnnouncementScreen = forwardRef((props, ref) => {
    const { user } = useAuth()
    const { data, loading, refresh } = useAnnouncements()
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)

    const isSuperAdmin = user?.IsSuperAdmin

    const handleCreate = () => {
        setSelectedAnnouncement(null)
        setModalOpen(true)
    }

    useImperativeHandle(ref, () => ({
        handleCreate,
    }))

    const handleEdit = (announcement) => {
        setSelectedAnnouncement(announcement)
        setModalOpen(true)
    }

    const handleModalClose = (shouldRefresh) => {
        setModalOpen(false)
        setSelectedAnnouncement(null)
        if (shouldRefresh === true) {
            refresh()
        }
    }

    const handleMarkAsRead = async (id) => {
        try {
            await AnnouncementService.markAsRead(id)
            refresh()
        } catch (e) {
            console.error(e)
        }
    }

    const handleDeactivate = async (id) => {
        try {
            await AnnouncementService.deactivate(id)
            refresh()
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <>
            <div className="my-1">
                <AnnouncementList
                    data={data}
                    loading={loading}
                    onEdit={handleEdit}
                    onDeactivate={handleDeactivate}
                    onMarkAsRead={handleMarkAsRead}
                    isSuperAdmin={isSuperAdmin}
                />
            </div>
            <AnnouncementModal
                open={modalOpen}
                onClose={handleModalClose}
                announcement={selectedAnnouncement}
            />
        </>
    )
})
